import { useParams } from "react-router-dom";
import { CompaniesEditPanel, PageHeader, PageHeaderV2 } from "@/components/organisms";
import { Restricted } from "..";
import { Container } from "@/components/atoms";

export const CompaniesEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) return <Restricted />;

  return (
    <Container className="flex flex-1 flex-col w-full mb-12">
      <PageHeaderV2 name="Companies" skipCrumbs={1} />
      <PageHeader.Actions />
      <CompaniesEditPanel companyId={id} />
    </Container>
  );
};
